import { render } from "./PaginationAsViewMore.vue?vue&type=template&id=2c1084d2"
import script from "./PaginationAsViewMore.vue?vue&type=script&lang=js"
export * from "./PaginationAsViewMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/PaginationAsViewMore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c1084d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c1084d2', __exports__)) {
    api.reload('2c1084d2', __exports__)
  }
  
  module.hot.accept("./PaginationAsViewMore.vue?vue&type=template&id=2c1084d2", () => {
    api.rerender('2c1084d2', render)
  })

}


export default __exports__